var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconJquery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 210,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109 8 L 112 9.5 Q 112.8 11.8 110.5 11 L 109 8 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 8 L 134.5 10 L 135.5 8 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 11 L 108.5 14 L 106.5 11 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 13 L 123.5 16 Q 120.5 14.5 123.5 13 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 13 L 133.5 14 Q 134.8 11.8 136 14.5 L 133.5 15 L 131.5 13 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 15 L 111 16.5 L 112 19.5 L 110 18.5 L 111.5 15 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 16 L 122 18 L 120 17.5 L 121.5 16 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 18 L 128 21.5 L 127 21.5 L 127.5 18 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 19 L 107 21 L 104.5 22 L 106.5 19 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 21 L 109 22.5 Q 109.8 24.8 107.5 24 L 109.5 21 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 24 L 75 24.5 L 72 25.5 Q 73.1 28.8 70.5 28 L 69 27.5 L 70 29.5 L 69 32 Q 66.3 33.1 67 30.5 L 67 28.5 Q 66.3 26.3 68.5 27 L 72.5 24 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 24 L 135.5 26 L 134.5 24 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 25 L 80 25.5 L 79 29.5 L 79.5 31 L 77 29.5 L 78 27.5 Q 75.8 26.2 78.5 25 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 25 L 90 25.5 L 88 26.5 L 88 25 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 25 L 94 26 L 93 30 Q 90.3 28.9 91 31.5 L 93 36.5 L 91 35.5 L 90 28.5 L 92 28.5 L 91.5 25 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 25 L 96 27.5 L 95 27.5 L 95.5 25 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 26 L 121 32.5 L 120 32.5 L 120.5 26 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 27 Q 137.5 26.1 136 30.5 L 135 30.5 L 134.5 27 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 32 L 66 34.5 L 65.5 36 L 64 33.5 L 65.5 32 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 32 L 80 32.5 L 78 37.5 Q 81.8 40.8 80 49 L 78 48.5 L 79 47.5 L 79 40 L 77 40 L 77 47.5 L 75 48 L 75 40.5 Q 78.3 41.5 77 35.5 L 77 33.5 L 77.5 32 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 32 L 89 35.5 L 88 35.5 L 88.5 32 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 32 L 104 34 L 102 33.5 L 103.5 32 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 32 L 142.5 34 L 143.5 32 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 33 Q 77.3 34.3 75 35.5 Q 76.5 39.9 73.5 39 L 74 37.5 L 74.5 33 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 33 L 175 34.5 L 172.5 35 L 171.5 33 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 35 L 121.5 37 L 122.5 35 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135 35 L 138 35.5 L 135.5 37 L 135 35 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 40 L 59 44.5 L 59 46.5 L 58.5 48 L 57 44.5 L 57 42.5 L 58.5 40 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 40 L 74 47.5 L 73 47.5 L 73.5 40 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108 40 Q 111 39 110 42 Q 107 43 108 40 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 40 L 146 42 L 148 42.5 L 146.5 43 L 145.5 40 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 40 L 164 41.5 L 162.5 41 Q 159.5 41.5 160.5 40 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 40 L 175 42.5 L 172 42.5 L 173.5 40 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 41 L 63 44 Q 60.3 42.9 61 45.5 L 61 47.5 L 60.5 50 L 60 43 L 62 42.5 L 61.5 41 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 41 L 105 43.5 L 104 43.5 L 104.5 41 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 41 L 125 42.5 L 123.5 42 L 122.5 41 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 43 L 112 46.5 L 111 46.5 L 110.5 43 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 43 L 121 45.5 L 120 45.5 L 120.5 43 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 43 L 128.5 46 L 130 46.5 L 127.5 47 L 125.5 47 L 122.5 48 L 123.5 46 Q 126.8 47.1 126 44.5 L 127.5 43 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 43 L 161 44.5 L 159.5 44 L 158.5 43 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 44 L 90 48.5 L 88 47.5 L 88.5 44 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 45 L 172 46.5 L 168.5 47 L 169.5 45 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 46 L 110 48.5 L 108 47.5 L 108.5 46 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 47 Q 94.5 47.5 94 51.5 L 92 52.5 L 93 50.5 L 91.5 47 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166 48 Q 168.7 46.9 168 49.5 Q 167.3 51.8 163.5 51 L 163.5 50 Q 167.3 51 166 48 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 49 L 110.5 51 L 111.5 49 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 50 L 91 56 Q 88.3 57.1 89 54.5 L 90.5 50 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 52 Q 80.5 53.5 77.5 55 L 76 54.5 L 75.5 56 L 75 53 L 77.5 52 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 52 L 133 53.5 L 131 54.5 L 130.5 52 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 53 L 60 54.5 L 58 56.5 L 57.5 63 L 57 55.5 L 59.5 53 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134 53 L 136 53.5 L 135.5 55 L 137 55.5 L 135.5 56 L 134 53 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 53 L 142 54.5 L 140.5 55 L 139.5 53 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 53 L 151.5 55 L 153 54.5 L 150.5 56 L 144.5 54 L 144.5 53 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 53 Q 160.8 52.3 160 54.5 L 158.5 53 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 56 L 79 56.5 L 77 57.5 L 77.5 59 L 75.5 60 L 75 58.5 L 77.5 56 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 56 L 117.5 59 L 119.5 58 L 118.5 60 L 116.5 61 L 115 59.5 L 116.5 56 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 57 L 169.5 59 L 168.5 57 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 57 L 175.5 59 L 174.5 57 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 59 L 98 59.5 L 96.5 62 L 96 59 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 64 Q 101.8 63.3 101 65.5 L 99.5 64 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 64 Q 128.3 62.8 127 66.5 L 126 66.5 Q 126.8 64.3 124.5 65 L 124.5 64 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 64 L 153.5 66 Q 150.7 66.7 152.5 64 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59 65 Q 62.7 63.8 61 69 L 59 68.5 L 59 66.5 L 59 65 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 65 Q 175.8 64.3 175 66.5 L 175.5 68 L 172.5 69 L 173.5 65 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 66 L 134.5 68 L 132.5 69 L 132 67.5 L 133.5 66 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 66 Q 162.8 65.3 162 67.5 L 159 69 L 160.5 66 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 67 L 80 70.5 L 79 70.5 L 78 68.5 L 79.5 67 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 68 Q 58.8 67.3 58 69.5 L 58.5 72 L 61.5 71 L 60 73.5 L 61 75.5 L 59 76.5 L 59 74.5 L 56.5 68 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 68 L 101.5 70 L 100.5 68 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 68 L 104.5 70 L 103.5 68 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 69 L 97 71.5 L 96 71.5 L 96.5 69 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 70 L 174.5 72 L 175.5 70 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 71 Q 109.3 72.3 107 73.5 L 108 75.5 L 106 74.5 L 107 72.5 L 106.5 71 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 75 L 88 77.5 L 87 77.5 L 87.5 75 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110 75 L 112 75.5 L 110 76.5 L 110 75 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 75 L 168 75.5 L 166 76 Q 167.1 78.7 164.5 78 L 163 78.5 L 164 76 L 166.5 75 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 78 L 58.5 79 L 60 78.5 Q 58.8 81.3 57.5 79 L 56.5 78 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 78 L 107 79.5 L 105.5 80 L 104.5 78 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 79 L 111 79.5 L 108.5 80 L 108.5 79 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 80 L 156.5 82 L 157.5 80 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 80 L 170 82.5 L 169 82.5 L 169.5 80 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 81 L 90 81.5 L 89.5 83 L 91.5 82 L 94 83 L 95 86.5 Q 93.5 89.5 92 86.5 L 94 85.5 L 88 82.5 L 88 81 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 81 L 174 84 L 172 83.5 L 172.5 81 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 82 L 150.5 84 L 151.5 82 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 83 L 67 86.5 L 65 85.5 L 65.5 83 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 83 L 125.5 83 Q 128.1 82.3 127 85 L 120.5 86 L 121 84.5 L 121.5 83 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 83 L 157 85 L 149.5 87 L 149.5 86 Q 153.3 87 152 84 L 155.5 84 L 156.5 83 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133 84 L 140 84.5 L 137.5 86 L 135.5 86 L 126.5 88 L 126.5 87 L 133 86 L 133 84 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 85 L 176 89.5 L 175.5 92 L 172 90.5 L 175 89.5 L 174.5 85 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 86 L 159.5 88 Q 156.7 88.7 158.5 86 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 87 L 144 87.5 L 136.5 88 L 136.5 87 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 88 L 164 88.5 L 160.5 90 L 161.5 88 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 88 L 167 89.5 L 164.5 91 L 164.5 90 Q 167 90.7 166.5 88 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 89 L 99 90.5 L 96 91 L 96 89 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 90 Q 64.3 94.3 67 95.5 L 65.5 95 Q 62.6 95.4 64.5 90 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68 91 L 70 91.5 Q 67.8 92.8 70.5 94 L 72 93.5 Q 70 97 68 92.5 L 68 91 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 92 Q 162.8 91.3 162 93.5 L 160.5 92 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 93 L 173 95.5 L 172 95.5 L 172.5 93 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 96 L 140 96.5 L 136.5 97 L 136.5 96 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73 97 L 75 97.5 L 73 98.5 L 73 97 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115 97 L 119.5 98 L 121.5 98 L 123.5 97 L 124.5 99 L 112.5 100 L 112.5 99 Q 116.3 100 115 97 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 97 L 148 98.5 L 149 100.5 L 147 99.5 Q 147.8 97.3 145.5 98 L 145.5 97 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 97 L 154.5 99 L 153 98.5 L 152.5 100 L 152 98.5 L 153.5 97 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 98 L 133.5 99 L 136 98 Q 134.7 101.3 139.5 100 L 140.5 102 L 136 102 Q 137.1 99.3 134.5 100 L 132.5 101 L 130.5 100 L 128 101 L 128.5 98 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 98 L 146 101.5 L 143.5 100 L 141 99.5 L 143.5 98 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166 99 Q 169.3 97.7 168 102.5 L 166 101.5 L 166 99 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 100 L 76 102.5 L 75.5 104 L 75 102.5 L 77.5 100 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 102 L 163.5 104 L 164.5 102 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 104 L 83 105.5 L 81 106.5 L 80.5 104 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 108 L 86 108.5 L 83.5 109 L 83.5 108 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 110 L 88.5 110 L 91 111.5 L 89.5 111 L 87.5 112 L 85.5 112 L 82 111.5 L 86.5 110 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 112 L 77 112.5 L 68.5 113 L 68.5 112 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 113 L 149.5 116 L 147 114.5 L 149.5 113 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 115 Q 77.3 114 76 117 L 73.5 115 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 115 L 148 116.5 L 146.5 117 L 144.5 115 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 116 L 72 116.5 L 65 117 L 64.5 120 L 64 117.5 L 65.5 116 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 117 L 101 117.5 L 100.5 119 L 107 119.5 L 100.5 120 L 97.5 119 L 96 118.5 L 98.5 117 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 117 L 142.5 118 L 144 117.5 Q 143 120 138.5 119 L 138.5 118 L 140.5 117 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 118 L 114 118.5 L 108.5 119 L 108.5 118 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 118 L 126 118.5 L 124 119.5 L 126.5 120 L 128 119.5 Q 126.5 123.9 129.5 123 L 134.5 124 L 134.5 123 L 132 121.5 L 135 119.5 L 134.5 118 L 137 118.5 L 136.5 120 L 140 121.5 L 137.5 122 L 134.5 121 L 134.5 122 L 137.5 124 Q 138.8 121.8 140 124.5 L 136.5 126 L 133.5 125 L 133.5 127 L 131.5 126 L 130 126.5 Q 130.7 123.9 128 125 L 127.5 129 L 126.5 128 L 120 128 L 120 125 L 112 125 L 112 121 Q 120.8 122.5 124.5 118 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 119 L 78 119.5 L 75.5 120 L 75.5 119 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 120 L 44 120.5 L 38 121.5 L 39 125 L 35.5 127 L 35 124.5 L 37 121 Q 33.3 119.5 34 122.5 L 33 122.5 L 34.5 120 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 120 L 53.5 122 L 51 122.5 L 51.5 124 Q 49.3 124.8 50 122.5 L 54.5 120 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56 120 L 60 120.5 L 58.5 122 L 56 121.5 L 56 120 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 120 L 83 120.5 L 80.5 121 L 80.5 120 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 120 Q 94.8 119.2 97.5 122 Q 98.8 119.8 103.5 121 L 103.5 122 L 92.5 123 L 88.5 121 L 86.5 122 L 86.5 121 L 88.5 120 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 120 L 201.5 122 L 199 121.5 L 200.5 120 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 122 L 42.5 124 L 45 122.5 L 44 125 L 46.5 124 L 47 126 L 43.5 127 L 43.5 125 L 40 124.5 L 41.5 122 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 122 L 49 123.5 L 47.5 123 L 46.5 122 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 123 Q 144.8 122.3 144 124.5 L 142 125.5 L 142.5 123 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 124 L 95.5 125 Q 96.8 122.8 101.5 124 L 104 125.5 L 96.5 127 L 93.5 126 Q 91.5 130 89.5 126 Q 86.9 125.3 88 128 Q 91 127 90 130 L 88 130.5 Q 90.2 131.8 87.5 133 L 87 128.5 Q 86.3 124.8 88.5 124 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 125 L 49 126.5 L 48.5 128 L 48 126.5 L 49.5 125 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102 127 L 105.5 129 L 109 128 L 108 130.5 L 109 132.5 L 107 132.5 L 108 134.5 L 106.5 134 L 105 133.5 L 105 131.5 Q 106 127.8 103 129 L 104 134.5 L 102 135 L 102 127 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 128 L 37 129.5 L 34.5 131 L 32 130.5 L 33.5 128 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 128 Q 151.1 127.2 150 130.5 L 148.5 130 L 147 129.5 L 148.5 128 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 128 Q 155.1 127.2 154 130.5 L 152.5 133 L 152 131.5 L 153 129.5 L 152.5 128 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 128 L 189.5 130 L 187 129.5 L 188.5 128 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 128 Q 208.8 127.3 208 129.5 L 206.5 128 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 131 L 185.5 136 L 183 135.5 L 183.5 131 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62 134 Q 65 133 64 136 Q 61 137 62 134 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 134 L 73.5 139 L 72 135.5 L 73.5 134 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 134 L 203.5 136 L 201 135.5 L 202.5 134 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 136 Q 90.2 137.3 88 138.5 Q 90 145.4 86 144 L 87.5 136 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 136 L 138 136.5 L 136.5 139 L 134.5 136 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 137 L 120 140.5 L 119 140.5 L 119.5 137 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 137 Q 173.1 136.2 172 139.5 L 171 139.5 L 170.5 137 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 138 L 63.5 142 L 64.5 141 L 72 141 L 73 144.5 L 71.5 144 L 63 144.5 L 64.5 146 L 72 146.5 L 63 147 L 62.5 145 L 61.5 147 L 59 145.5 L 62 144.5 L 59 142.5 L 61.5 138 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 139 L 108 140.5 L 105 144.5 L 106 146.5 L 104 147.5 L 104 145.5 Q 104.7 142.9 102 144 Q 103.1 146.7 100.5 146 L 99 146.5 L 99.5 144 L 103.5 141 L 104.5 144 L 107.5 139 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 140 L 168 141.5 L 167 142.5 L 168.5 145 L 164.5 143 L 163 143.5 L 167 141.5 L 165.5 140 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 141 L 171.5 144 Q 168.5 142.5 171.5 141 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 141 Q 200.5 142.5 197.5 144 L 195 143.5 L 197 143 L 197.5 141 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 143 L 32 144.5 L 33 146.5 L 31.5 146 L 24.5 146 L 24 144 L 31.5 144 L 32.5 143 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 145 L 118 147.5 L 118 149.5 L 117.5 152 L 116 148.5 L 117.5 145 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 145 L 170 146.5 L 168.5 149 L 168.5 146 L 170.5 145 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 145 L 197.5 147 Q 199.8 147.8 199 145.5 L 200 145.5 L 199 147.5 L 199.5 149 L 196.5 148 L 196.5 149 L 198 149.5 L 196.5 150 Q 193.8 148.8 196 147.5 L 197.5 145 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 146 L 165.5 150 L 167 149.5 L 168 154 L 173 154 L 173 155.5 L 171.5 155 Q 167.5 154.5 167 157.5 Q 168 161.3 165 160 L 166 156 L 163 157.5 Q 163.8 159.8 161.5 159 Q 158.5 157.5 161.5 156 Q 163.8 156.8 163 154.5 L 165 154.5 Q 166.3 150.8 162.5 152 L 163 150.5 Q 162.3 146.8 164.5 146 Z M 166 154 Q 165 157 168 156 Q 169 153 166 154 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150 147 L 152 147.5 L 149 149.5 L 150 147 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 147 L 176 150.5 L 174 151 L 173.5 153 L 171 152.5 L 170 149.5 L 171 149.5 L 171.5 151 L 174 150 L 174.5 147 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 148 L 47.5 150 L 46.5 152 Q 43.5 151.1 45 155.5 Q 46.3 158.3 47.5 156 L 49.5 155 Q 53 157 48.5 159 L 48.5 157 L 46 158.5 L 48 163 L 45 161.5 L 45 159.5 L 44.5 157 L 43.5 160 L 43 157.5 L 44 154.5 L 45 151.5 L 44.5 148 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 148 L 72 148.5 L 64.5 149 L 64.5 148 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 148 L 134 150 L 132 149.5 L 133.5 148 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146 148 L 148 148.5 L 146 149.5 L 146 148 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 149 L 192.5 151 L 195.5 152 L 197.5 152 L 208 152 L 208 158 L 192 158 L 192 151.5 Q 189.7 150.3 192.5 149 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24 150 L 31.5 150 L 32 151.5 Q 30.8 154.3 29.5 152 L 27.5 153 Q 26.2 150.8 25 153.5 L 25.5 155 Q 23.3 155.8 24 153.5 L 24 151.5 L 24 150 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 150 L 144 150.5 L 136.5 151 L 136.5 150 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 152 Q 149.8 151.3 149 153.5 L 147.5 152 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 152 L 191 152.5 L 188.5 154 L 189.5 152 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 153 L 176 154.5 L 174 155.5 L 175.5 153 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 154 L 190 155.5 L 189 157.5 L 189.5 159 L 187.5 160 L 187 158.5 L 187.5 156 L 190.5 154 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 155 L 149 157.5 L 147 158.5 L 148.5 155 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 156 Q 29.8 155.3 29 157.5 L 26 157.5 L 27.5 156 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 156 L 118 159 L 123 159.5 L 119 160.5 L 119.5 162 L 116.5 160 L 115 157.5 L 116.5 156 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 157 L 26 159.5 Q 22.9 161.2 24.5 163 L 22.5 162 L 22.5 164 Q 19.5 164.9 21 160.5 L 23.5 160 L 25 159.5 L 24.5 157 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 159 L 90 159.5 L 87.5 160 L 87.5 159 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16.5 160 L 17.5 162 L 18.5 160 Q 21.5 161.5 18.5 163 L 16 161.5 L 16.5 160 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 160 L 98 160.5 L 96 161.5 L 96 160 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 160 L 107.5 162 L 106.5 160 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 160 L 132.5 163 L 134.5 160 L 136 166.5 L 134 167.5 L 133.5 165 L 132 168 Q 127.1 169.8 129 163.5 L 131.5 160 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 161 L 92 163.5 L 90.5 166 L 88.5 161 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 161 L 150 163 L 148.5 168 L 145.5 163 L 143.5 164 Q 142.3 161.8 141 164.5 L 139.5 168 L 138 165.5 L 139.5 162 L 141.5 162 L 144.5 161 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72 162 L 80 162 L 80 166 L 72 166 L 72 162 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 162 Q 106.8 161.3 106 163.5 L 104.5 162 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 162 Q 116.3 161.3 117 163.5 L 119 167.5 L 116.5 168 L 113 164.5 L 112.5 162 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 163 L 104 164.5 Q 105.5 168.9 102.5 168 L 102.5 164 L 101.5 163 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 164 L 47 166.5 L 46.5 168 L 46 166 L 44 166.5 L 44.5 168 Q 42 167 43.5 164 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 164 L 111 164.5 Q 108.9 167.8 108.5 164 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19.5 165 L 20 168 L 18 167.5 L 19.5 165 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 165 L 108 167.5 L 105.5 168 L 106 166.5 L 106.5 165 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48 168 L 64 168 L 64 176 L 48 176 L 48 168 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184 168 L 186 168.5 L 184 169.5 L 184 168 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 169 L 73.5 171 L 72.5 169 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 170 L 188 172.5 L 186.5 176 L 186 173.5 L 187 171.5 L 186.5 170 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 171 L 132.5 173 L 131.5 171 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 172 L 91 174.5 L 89 173.5 L 89.5 172 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 172 L 109 173.5 L 106 175 L 106.5 173 L 108 173.5 L 108.5 172 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 17.5 174 L 18 176 L 16 175.5 L 17.5 174 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,252)",
    stroke: "rgb(254,254,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 181 L 136 182.5 L 133.5 183 L 132.5 181 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121 10 Q 124.7 8.8 123 14 Q 119.3 15.2 121 10 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 10 L 125.5 12 L 126.5 10 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 11 L 108.5 15 L 105.5 11 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 16 L 100.5 18 L 99.5 16 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97 20 Q 100 18.8 99 22.5 L 97 21.5 L 97 20 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 24 Q 71.9 22.5 71 25.5 L 69.5 25 Q 66.5 25.5 67.5 24 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 25 L 73.5 27 L 74.5 25 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 26 L 133.5 29 Q 130.5 27.5 133.5 26 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 27 L 129.5 29 L 128.5 27 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 29 L 72 29.5 L 67.5 33 L 67.5 32 Q 69.8 32.8 69 30.5 L 70.5 29 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 29 L 78 30 Q 79 33 76 32 L 75.5 29 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 29 L 89 30.5 L 88.5 32 L 88 30.5 L 89.5 29 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 29 L 94 30.5 L 93.5 32 L 93 30.5 L 94.5 29 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 30 L 134.5 32 L 133.5 30 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 32 L 91 38.5 L 90 38.5 L 90.5 32 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 33 L 94 35.5 L 93 35.5 L 93.5 33 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141 35 Q 145.1 33.7 144 37 Q 139.9 38.3 141 35 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 37 L 77 40 Q 74.3 41.1 75 38.5 L 76.5 37 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 37 L 140 40 L 137 38.5 L 139.5 37 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 39 L 121 40.5 L 120.5 42 L 120 40.5 L 121.5 39 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59 40 Q 62 38.8 61 42.5 L 59 43.5 L 59 40 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 40 L 127 42.5 L 125 43 L 125.5 40 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 40 L 143.5 43 L 141 41.5 L 143.5 40 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160 41 Q 163 40 162 43 Q 159 44 160 41 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 41 L 172 43.5 L 168.5 45 L 170 42.5 L 170.5 41 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108 42 Q 112 40.6 110 47.5 L 109 47.5 L 108 42 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 44 L 105.5 46 L 104.5 44 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 46 L 167.5 48 L 165 47.5 L 166.5 46 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 47 L 130 47.5 L 126.5 48 L 126.5 47 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 47 L 136 52 L 132 50.5 L 133 48.5 L 132.5 47 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 50 Q 76.8 51.8 74 53.5 L 73.5 55 L 72.5 50 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 52 L 61 54.5 L 60 54.5 L 60.5 52 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 52 L 89 55.5 L 88 55.5 L 88.5 52 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 52 L 110.5 54 L 111.5 52 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 53 L 136.5 55 L 137.5 53 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161 53 L 165 53.5 L 161.5 55 L 161 53 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 56 L 80 58.5 L 79 58.5 L 79.5 56 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 56 L 172 56.5 Q 171.2 59.5 175 58 L 175 61.5 L 174 61.5 L 173.5 59 L 169 62.5 L 172 58 L 169.5 56 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 60 L 120 61.5 L 118 62.5 L 119.5 60 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 61 L 80 65.5 L 79 65.5 L 78.5 61 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 63 L 99 64 L 100 68.5 L 97 66.5 L 98 65.5 L 96.5 63 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57 64 Q 60.7 62.8 59 68 Q 55.3 69.2 57 64 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 64 L 164 64.5 L 161.5 65 L 161.5 64 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 64 L 165.5 67 L 167.5 64 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 65 L 171.5 67 L 172.5 65 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 67 Q 155.5 68.5 152.5 70 L 152.5 67 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 68 Q 175.8 67.3 175 69.5 Q 173.5 72.5 172 69.5 L 173.5 68 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 70 L 105 72.5 L 104.5 75 L 104 72 Q 99.5 73.3 101.5 70 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 72 L 63 75.5 L 62 75.5 L 61.5 72 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 73 L 59 77.5 L 56 75.5 L 56.5 73 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 74 L 164.5 76 L 165.5 74 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 76 L 161.5 78 L 162.5 76 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 77 L 84.5 79 L 83.5 77 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 77 Q 113.5 76.5 114 79.5 L 112 80 Q 113.3 77 109.5 78 L 109.5 77 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 79 L 165 79.5 L 162.5 80 L 162.5 79 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 80 L 160 83.5 L 159 83.5 L 159.5 80 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 81 L 153.5 83 L 152 82.5 L 154.5 81 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64 82 L 66 82.5 L 64.5 86 L 64 82 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 82 L 125 82.5 L 122.5 83 L 122.5 82 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 83 L 96 85.5 L 95 85.5 L 95.5 83 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 85 L 131 85.5 L 127.5 87 L 128.5 85 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 86 L 146 86.5 L 143.5 87 L 143.5 86 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 87 L 124 87.5 L 121.5 88 L 121.5 87 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 87 L 136 87.5 L 132.5 88 L 132.5 87 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 88 L 97 88.5 Q 94.9 91.8 94.5 88 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 89 L 68 92.5 L 66 91.5 L 65.5 89 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 89 Q 165.5 90.5 162.5 92 L 162.5 89 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 91 L 100.5 94 L 98.5 91 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 96 L 143.5 98 L 144.5 96 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 97 L 79.5 102 L 75 99 L 74.5 101 L 74 98.5 L 75.5 97 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 97 L 152 97.5 L 149.5 98 L 149.5 97 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 97 L 167 98.5 L 165 99.5 L 166.5 97 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136 98 L 138 98.5 L 136 99.5 L 136 98 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 101 L 161.5 104 L 163.5 101 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 106 L 86.5 108 L 85.5 106 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80 108 L 83 109.5 L 80 111 L 80 108 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 109 Q 160.8 107.9 160 110.5 L 158.5 110 L 157.5 109 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 112 L 148.5 114 L 149.5 112 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 117 L 106 118.5 L 102.5 119 L 103.5 117 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 117 L 147.5 119 L 146.5 117 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 118 L 120 118.5 L 117.5 119 L 117.5 118 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 118 L 131 118.5 L 128.5 119 L 128.5 118 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 119 L 112 119.5 L 109.5 120 L 109.5 119 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 126 L 208 128 L 206 127.5 L 207.5 126 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 131 L 73.5 133 L 74.5 131 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 132 L 90.5 134 L 89.5 132 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 138 L 139.5 140 L 138.5 138 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 153 L 49.5 155 L 48.5 153 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101 160 L 103 160.5 L 101 161.5 L 101 160 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 160 L 143 160.5 Q 141.8 163.3 140.5 161 Q 137.5 161.5 138.5 160 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146 160 L 148 160.5 L 146 161.5 L 146 160 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 161 Q 113.1 160.3 112 163 L 108.5 164 L 107.5 162 L 110.5 161 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 162 L 89 164.5 L 88 164.5 L 88.5 162 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 163 Q 121.5 162.1 120 166.5 L 119 166.5 L 118.5 163 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 163 L 138 164.5 L 136 165.5 L 137.5 163 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 164 L 152 167 L 150 166.5 L 151.5 164 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 165 Q 97.8 164.3 97 166.5 L 95.5 165 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 165 L 115 166.5 L 116 168.5 L 114 167.5 Q 114.8 165.3 112.5 166 L 112.5 165 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 165 Q 146.3 164.3 147 166.5 L 146.5 168 L 143.5 166 L 141 167.5 L 142.5 165 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 166 L 92.5 169 Q 89.5 167.5 92.5 166 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 166 L 102 167.5 L 99.5 168 L 98.5 166 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 166 L 109 167.5 L 108.5 169 L 108 167.5 L 109.5 166 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134 170 L 136 170.5 L 134 171.5 L 134 170 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 171 L 20.5 173 L 21.5 171 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 171 Q 192.3 172.3 190 173.5 L 189.5 176 L 189.5 171 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 173 L 89.5 175 L 90.5 173 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,254,254)",
    stroke: "rgb(249,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 173 L 136 177.5 L 135 177.5 L 134.5 173 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 13 L 126 14.5 Q 125.4 34.1 137.5 41 L 148.5 46 L 156.5 47 L 164.5 45 L 167.5 42 L 168 43.5 L 158.5 51 L 145.5 52 L 142.5 51 Q 131.6 47.9 126 39.5 L 122 30.5 L 122 21.5 L 126.5 13 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 19 L 102 20.5 Q 99.7 27.2 101 37.5 Q 104.8 53.2 115.5 62 L 127.5 70 L 133.5 72 Q 141.4 74.6 153.5 73 Q 165.1 70.6 171.5 63 L 171 64.5 Q 168 72 161.5 76 Q 151.9 83.4 134.5 83 Q 133 80.5 127.5 82 L 115.5 77 L 102 64.5 L 95 50.5 L 94 36.5 Q 95.8 25.3 102.5 19 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 28 L 74 29.5 L 71 40.5 L 71 49.5 Q 75.6 77.4 94.5 91 Q 109.3 103.7 135.5 105 L 136.5 104 L 144.5 104 L 156.5 100 L 168.5 91 L 168 92.5 Q 164.4 100.9 157.5 106 Q 144.2 118.7 117.5 118 L 100.5 114 Q 88.1 108.4 79 99.5 L 77 96.5 Q 69.7 90.3 66 80.5 L 62 67.5 L 61 58.5 L 65 40.5 L 74.5 28 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 120 Q 79.5 118.5 84 126.5 Q 86.9 130.1 86 137.5 L 81 150.5 L 85 152 L 84 159 L 76.5 159 L 75.5 160 L 61.5 160 L 56.5 159 L 50 154.5 Q 46.3 150.2 48 140.5 Q 50.3 127.8 59.5 122 L 65.5 120 Z M 67 128 L 65 129 Q 56 133 58 149 L 61 151 L 73 151 L 76 140 L 76 132 Q 74 127 67 128 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 124 L 206.5 124 L 207 125.5 L 187 151.5 L 185 159 L 176 159 L 176 155.5 Q 178.3 154.2 177 149.5 Q 173.8 145 174 138 L 182.5 138 L 183 140.5 Q 185 144 187 139.5 L 197.5 124 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38 128 L 46.5 128 L 47 130.5 L 44.5 136 L 37 136 L 37 132.5 L 38 128 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 128 Q 99.5 126.5 101 129.5 L 97 149.5 Q 98.5 153.5 105.5 152 L 107 150.5 L 109 137.5 L 112.5 128 L 119 128 L 119 133.5 L 113 159 L 93.5 159 L 90 156.5 L 89 154.5 L 89 142.5 L 92 129.5 L 93.5 128 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 128 Q 145 126 149 132.5 L 150 139.5 Q 147.7 140.8 149 145.5 L 147.5 147 L 128.5 147 L 128 149.5 L 131.5 152 L 146 152 L 145 160 L 128.5 160 L 122.5 158 L 120 155.5 Q 117.7 152.3 119 145.5 L 123 134.5 L 127.5 130 L 132.5 128 Z M 136 135 L 133 136 L 130 140 L 141 140 L 141 138 L 136 135 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 128 L 176.5 128 L 181 130.5 L 182 136 L 163.5 136 L 163 139.5 Q 159.3 148.1 159 159 L 150.5 159 L 150 157.5 L 156 129.5 L 157.5 128 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36 138 L 44.5 138 L 45 139.5 L 40 162.5 Q 38.8 168.3 34.5 171 L 32.5 172 L 23 172 L 24 164 Q 28.6 165.3 30 162.5 L 36 138 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 167 L 113 167.5 L 110.5 175 L 110 171.5 L 111 168.5 L 110.5 167 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 167 L 144 171.5 L 143 175 L 138 175 L 138 171.5 Q 139.2 168.3 143 169 L 143.5 167 Z M 141 171 L 139 173 L 142 174 Q 143 170 141 171 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 168 Q 100.8 169.8 97 171.5 L 98 174.5 L 96 175 Q 94.5 169.6 97.5 168 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 169 L 79.5 172 L 81.5 169 Q 84.1 168.2 83 171.5 L 84 171.5 L 85.5 169 L 85 170.5 L 84 175 L 80 173 Q 81.1 176.3 77 175 Q 75.8 170.4 78.5 169 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 169 Q 92.3 167.8 91 171.5 L 89.5 171 Q 86.9 170.2 88 173.5 L 86 174.5 L 88.5 169 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 169 Q 95.9 168.1 94 173.5 L 92 174.5 L 93 170.5 L 92.5 169 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 169 L 106 170.5 L 104.5 173 L 101 173.5 L 105 174.5 L 100 175 Q 99 170.3 102.5 169 Z M 104 170 L 102 172 L 104 172 L 104 170 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 169 Q 118.8 167.9 118 170.5 Q 120.3 171.8 117.5 173 L 114 173.5 L 117 174.5 L 113 175 Q 112 170.3 115.5 169 Z M 117 170 L 115 172 L 117 172 L 117 170 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 169 L 125 169.5 L 122 170 Q 121 173 124 172 L 124 175 L 120 174.5 L 123 173.5 L 120 173 L 121.5 169 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 169 L 131 169.5 L 128 170 Q 126.8 173 130.5 172 L 130 173.5 Q 130.9 176.5 126.5 175 L 126.5 174 L 129 173.5 L 126 171.5 L 128.5 169 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 169 L 151 170.5 L 150 175 L 145 175 L 145 171.5 L 147.5 169 Z M 146 171 Q 145 176 149 174 L 150 172 L 146 171 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156 169 L 160.5 170 L 163 169 L 162.5 175 L 162 171 Q 159 169.8 160 173.5 L 158 174.5 L 159 171 Q 156.3 169.9 157 172.5 L 155.5 175 L 155 172.5 L 156 169 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 169 L 170 170.5 Q 170.8 174.3 168.5 175 Q 164.8 175.8 164 173.5 L 166.5 169 Z M 168 170 L 166 174 L 169 173 L 168 170 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 169 Q 177.3 168 176 171 L 173 171 Q 174.7 176.2 171 175 L 173.5 169 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(26,73,112)",
    stroke: "rgb(26,73,112)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 169 Q 182.8 167.9 182 170.5 Q 184.3 171.8 181.5 173 L 179 173.5 L 181 174.5 L 177 175 Q 176 170.3 179.5 169 Z M 179 170 Q 178 173 181 172 Q 182 169 179 170 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 8 L 131 8.5 L 131 16 Q 126.5 17.8 128 12.5 L 130 9.5 L 129.5 8 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 10 L 108.5 15 L 110 15.5 L 106 16 Q 107 13 104 14 L 104.5 10 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 16 L 99 18.5 L 99.5 20 L 101 19.5 Q 99 23 97 18.5 L 100.5 16 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 24 L 70 25.5 L 66 26 Q 67.3 30.6 64.5 32 L 64 30.5 L 65 27.5 L 64.5 26 Q 67 26.7 66.5 24 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 24 L 93.5 24 L 96 24.5 L 92.5 26 L 91.5 24 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 24 L 133 25 L 135 30.5 L 133 31.5 L 134 28.5 L 133 28.5 L 132.5 30 L 132 28.5 Q 134.8 26.8 130.5 25 Q 127.5 25.5 128.5 24 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 26 L 80 28.5 L 79 28.5 L 79.5 26 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 27 L 77 29.5 L 76 29.5 L 76.5 27 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 27 L 90 28.5 L 89.5 31 Q 87 30 88.5 27 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 31 L 93.5 33 L 92.5 31 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 32 L 90 35.5 L 89 35.5 L 89.5 32 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 33 L 80 37.5 L 79 37.5 L 79.5 33 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 34 L 144 34.5 L 141 35 L 142 37.5 L 140.5 40 L 139 36.5 L 141.5 34 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 35 L 77 36.5 L 75 37.5 L 76.5 35 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 35 Q 173.3 33.3 172 37.5 L 173 37.5 Q 171.8 33.8 175.5 35 L 176 37.5 L 175.5 43 L 175 40 Q 171.3 38.5 172 41.5 L 171 41.5 L 172 39.5 L 170.5 37 L 170 39 L 168 38.5 L 169 36.5 L 168.5 35 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 36 Q 67.5 37.5 64.5 39 L 64.5 36 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 36 L 123 39.5 L 120 37.5 L 120.5 36 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 39 L 93 40 Q 94 44.3 91 43.5 L 91 48 Q 88.3 46.9 89 49.5 L 88 49.5 L 89 40.5 L 90.5 39 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 40 L 108 41.5 L 105.5 42 L 104.5 40 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 40 Q 113.5 41.5 110.5 43 L 110.5 40 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 40 Q 152.8 38.9 152 41.5 L 150.5 41 L 146.5 42 L 146.5 41 L 149.5 40 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 40 Q 161.1 39.3 160 42 L 157 41.5 L 158.5 40 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 43 Q 125.8 42.3 125 44.5 L 120.5 48 L 120 46.5 L 123.5 43 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 44 L 60 46.5 L 59 46.5 L 59.5 44 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 44 L 160 44.5 L 152.5 45 L 152.5 44 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 45 L 111 47.5 L 110 47.5 L 110.5 45 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 45 L 130.5 47 L 129.5 45 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 48 L 59 52 Q 56 50.8 57 54.5 L 56 54.5 L 58 49.5 L 57.5 48 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75 48 L 78 48.5 L 75 50 L 74.5 52 L 73.5 50 Q 76.1 50.7 75 48 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131 48 L 133 48.5 L 132 50.5 Q 133 53 137.5 52 L 139 51.5 L 137.5 55 L 137.5 53 Q 132.3 54.3 131 51.5 L 131 48 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 50 L 93 55.5 L 92 55.5 L 91.5 50 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 52 L 80 55.5 L 79 55.5 L 79.5 52 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 52 L 167 53.5 L 165 54.5 Q 165.8 51.9 162.5 53 L 162.5 52 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 53 L 75 55.5 L 74 55.5 L 74.5 53 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 53 L 131 54.5 Q 131.8 57.1 128.5 56 L 128.5 53 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 53 L 150 53.5 L 147.5 54 L 147.5 53 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 55 L 148 55.5 L 144.5 56 L 144.5 55 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 56 L 57 60.5 L 56 60.5 L 56.5 56 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 56 L 59 58.5 L 58 58.5 L 58.5 56 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 56 L 61 63.5 L 60 63.5 L 60.5 56 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 56 L 114.5 58 L 113.5 56 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 56 L 120 58 L 118 57.5 L 119.5 56 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78 59 Q 81 58 80 61 Q 77 62 78 59 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 59 L 170 61.5 L 168 60.5 L 168.5 59 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 63 L 78.5 65 L 77.5 63 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 64 Q 135.8 63.3 135 65.5 L 135.5 67 L 132 65.5 L 133.5 64 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 65 L 155 67 L 153 66.5 L 154.5 65 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 65 L 160 66.5 L 158.5 66 Q 155.5 66.5 156.5 65 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 66 L 100 67.5 L 98.5 70 L 97 67.5 L 99 67.5 L 99.5 66 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 68 L 60 71.5 L 59 71.5 L 58.5 68 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 69 L 154 71 L 152 70.5 L 153.5 69 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 72 L 59 75.5 L 57 74.5 L 56.5 72 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 72 L 106 74.5 L 104 75.5 L 105.5 72 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 74 L 87 75.5 L 86 78 L 84 77.5 L 86.5 74 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106 76 L 110 76.5 L 107 77.5 L 111 78.5 L 107.5 79 L 106 76 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60 78 L 65 79.5 L 60 80 L 60 78 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165 78 L 168 78.5 L 165.5 80 L 165 78 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 80 L 160 85.5 L 158 84.5 L 158.5 80 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 83 L 149 83.5 L 146.5 84 L 146.5 83 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 84 L 91.5 86 L 90.5 84 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 84 L 130 84.5 L 120.5 88 L 121.5 86 L 128.5 84 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 85 L 151 87.5 L 148.5 88 L 144.5 86 L 144.5 85 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 86 Q 66.3 89.1 68 87.5 L 66 91.5 L 68 91.5 L 67.5 94 Q 65.3 94.8 66 92.5 L 65 90.5 Q 67.5 89 64 87.5 L 64.5 86 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 86 L 143 86.5 L 136.5 87 L 136.5 86 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 86 L 157 86.5 L 153.5 88 L 153.5 87 L 155.5 86 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 88 L 100.5 90 L 102 89.5 Q 102.7 92.5 99 91 Q 100.1 88.3 97.5 89 L 97.5 88 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 88 L 164.5 90 L 163 89.5 L 165.5 88 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173 91 L 176 92.5 Q 176.8 94.8 174.5 94 L 173 91 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112 96 L 121 96.5 L 112 98 L 112 96 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 96 L 126 96.5 L 123.5 97 L 123.5 96 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 96 L 142.5 97 L 144 96.5 Q 142.3 99.8 137.5 100 L 137.5 98 L 128.5 98 Q 127.1 100.6 122.5 100 L 122.5 99 L 128 97.5 L 127.5 96 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 96 L 150 96.5 Q 147.9 99.8 147.5 96 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 96 L 156 96.5 L 152.5 98 L 153.5 96 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 99 L 120 99.5 L 116.5 100 L 116.5 99 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 100 L 74.5 102 L 73 101.5 L 75.5 100 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 101 Q 135.5 100 139 102.5 L 136.5 103 L 134.5 103 Q 128.8 103.8 128.5 101 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 101 L 166.5 104 L 164.5 101 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 102 L 83.5 106 L 80.5 102 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 108 Q 85.5 109.5 82.5 111 L 82.5 108 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 113 L 152 116.5 L 151 116.5 L 151.5 113 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 117 L 101.5 119 L 102.5 117 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 117 Q 107.8 115.9 107 118.5 L 105.5 118 L 104.5 117 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 117 L 146.5 118 L 148.5 117 L 150 120 Q 147.3 121.1 148 118.5 L 145.5 118 L 144.5 117 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 118 L 120 119.5 L 112.5 120 L 112.5 119 L 116.5 118 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 119 L 140 119.5 L 136.5 120 L 136.5 119 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 120 L 51 122 L 49 121.5 L 50.5 120 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 120 L 62 120.5 L 59.5 122 L 60.5 120 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85 120 L 88 120.5 L 85.5 122 L 85 120 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 120 L 196 121.5 L 195.5 123 L 199.5 122 L 199.5 123 Q 195 122.5 194.5 126 L 192 122.5 L 194 121.5 L 193.5 120 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 121 L 204.5 122 L 206 121.5 Q 205.3 123.8 201.5 123 L 202.5 121 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 122 L 56.5 124 L 57.5 122 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 123 Q 84.8 122.3 84 124.5 L 85.5 127 L 82.5 123 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 128 L 91 129.5 L 89.5 139 L 89 133.5 L 90 131.5 Q 87.2 129.7 91.5 128 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109 128 L 111 128.5 L 109.5 132 L 109 128 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 128 L 122.5 128 L 125.5 130 L 127 129.5 L 123 132.5 L 120.5 128 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 129 L 74 130 L 76 136.5 L 73.5 143 L 73 139.5 L 75 134.5 L 72.5 131 L 68.5 130 L 65.5 131 L 66.5 129 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 130 L 34 136 L 32 135.5 L 32 133.5 L 33.5 130 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 130 L 102 136 L 104 136 Q 102.9 133.3 105.5 134 L 104 136.5 L 105 139.5 L 102 141.5 Q 103.3 135.4 100.5 136 L 101 134.5 L 101.5 130 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 130 L 192 130.5 L 187.5 137 L 186 133.5 L 189 132 L 189.5 130 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 131 L 60.5 135 L 63.5 131 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 131 L 105.5 133 Q 102.7 133.7 104.5 131 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 131 L 151 134.5 L 150 134.5 L 149.5 131 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 132 Q 51.5 133.5 48.5 135 L 48.5 132 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 132 L 72 132.5 L 67.5 133 L 67.5 132 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153 132 Q 155.7 130.9 155 133.5 L 152 135.5 L 153 132 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35 136 L 37 136.5 L 33.5 143 L 33 140.5 L 35 136 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 136 L 64 138.5 L 63 138.5 L 63.5 136 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107 136 L 109 136.5 L 107.5 139 L 107 136 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 137 L 134.5 140 L 132.5 139 L 131 139.5 L 132.5 137 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 137 L 154 139.5 L 153 139.5 L 153.5 137 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 137 L 168 140 L 166 139.5 L 167.5 137 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 138 L 48 140.5 L 45 142.5 L 46.5 138 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 138 L 119 144.5 L 118 144.5 L 118.5 138 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 138 L 199 140 L 196.5 141 L 198.5 138 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 139 L 87 141.5 L 86 141.5 L 86.5 139 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 139 L 173 141.5 L 172 141.5 L 172.5 139 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 141 L 170 142.5 L 167.5 143 L 166.5 141 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 142 L 59 145.5 L 58 145.5 L 58.5 142 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 142 L 152 144.5 L 150 143.5 L 150.5 142 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 143 L 85 144.5 L 84 151 L 82 150.5 L 84 146.5 L 85.5 143 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 143 L 104 144.5 L 103.5 147 Q 100 145 104.5 143 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 143 L 165 144 L 162.5 148 L 162 145.5 L 162.5 143 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 144 L 47 149.5 L 46 149.5 L 46.5 144 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 144 L 107 146.5 L 105.5 150 L 105 147.5 L 106.5 144 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 144 Q 169.1 143.2 168 146.5 L 167 146.5 L 166.5 144 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 145 L 99 149.5 L 98 149.5 L 98.5 145 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 147 Q 61.3 150.1 63 148.5 L 60 150 L 59.5 147 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 148 L 104 151 Q 100.5 152.1 102.5 148 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 149 L 72 149.5 L 64.5 150 L 64.5 149 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 149 L 151 152.5 L 149 151.5 L 150.5 149 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 149 L 162 151.5 L 161 151.5 L 161.5 149 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 150 L 136 150.5 L 130.5 151 L 130.5 150 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 151 L 48 152.5 L 46 153.5 L 47.5 151 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 152 L 44 154.5 L 41.5 160 L 42 158.5 Q 41.3 153.8 43.5 152 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86 152 Q 89 150.8 88 154.5 L 88.5 156 L 86.5 155 L 85 155.5 L 86 152 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 154 L 47.5 156 L 48.5 154 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 154 L 121 157.5 L 119 158.5 L 118.5 154 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 157 L 54 158.5 L 52.5 159 L 51.5 157 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 157 L 86 158.5 L 84 159.5 L 85.5 157 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 157 L 91 158.5 L 88 158.5 L 88 157 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 159 L 92.5 161 L 95 161.5 Q 93.8 164 90 163 L 92.5 159 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 159 L 116 162 L 112 160.5 L 114 160.5 L 114.5 159 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 160 L 30 160.5 L 26 163 L 27.5 160 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 160 L 104 162.5 L 102 161.5 L 103.5 160 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 160 L 142.5 162 L 143.5 160 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148 160 Q 151 159 150 162 Q 147 163 148 160 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 161 L 141 161.5 L 136.5 164 L 136 162 L 138.5 161 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 162 L 107.5 164 Q 104.7 164.7 106.5 162 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 162 L 152 163.5 L 150.5 166 L 150 164.5 L 151.5 162 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 163 L 98 165 L 102 166.5 L 100.5 167 L 96 164.5 L 97.5 163 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 164 L 111.5 166 L 112.5 164 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 164 L 120 167.5 L 118 166.5 L 118.5 164 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 165 L 105 167.5 L 104 167.5 L 104.5 165 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 165 L 138 166.5 L 136 167.5 L 137.5 165 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 166 L 90.5 168 L 91.5 166 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 20 168 L 23 168.5 L 21.5 171 L 20 168 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 168 L 189 168.5 L 191 171.5 L 189 171.5 L 188.5 176 L 188 171.5 L 188.5 170 L 186.5 168 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 169 L 75 170.5 L 74.5 172 L 74 170.5 L 75.5 169 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 170 L 37.5 172 L 33.5 173 L 33.5 172 L 36.5 170 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 170 L 152.5 172 L 153.5 170 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 172 L 32 173.5 L 24 174 Q 25.1 177.3 21 176 Q 19.9 173.3 22.5 174 L 22.5 173 L 21.5 172 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 173 Q 40.8 172.3 40 174.5 L 37 176 L 38.5 173 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,255,255)",
    stroke: "rgb(254,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128 176 Q 131.4 175.3 132.5 178 L 135 176.5 L 136 181 L 128 181 L 128 176 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 0 L 230 0 L 230 210 L 0 210 L 0 0 Z M 109 8 L 109 10 L 112 11 Q 114 7 109 8 Z M 121 8 L 121 10 L 120 16 L 122 15 L 120 18 L 120 33 L 122 33 L 122 34 L 120 35 L 120 48 L 124 47 L 126 48 Q 129 47 128 50 L 131 51 L 130 51 L 131 54 L 130 53 Q 127 52 128 56 L 132 56 L 132 55 L 134 54 Q 133 58 139 56 L 141 56 Q 147 58 149 55 L 152 56 L 155 55 L 157 56 L 165 56 L 164 55 L 164 54 L 168 56 Q 169 52 167 53 L 168 51 Q 167 47 171 48 L 173 48 L 173 45 L 171 46 L 173 43 L 174 45 L 174 44 L 176 44 L 176 36 Q 175 33 174 35 L 174 34 L 171 32 L 168 34 L 172 34 L 172 35 L 168 35 L 168 40 L 159 40 L 158 41 Q 153 42 152 40 L 149 41 L 147 40 L 144 42 L 146 42 L 146 43 L 143 42 L 144 38 L 142 39 L 143 37 Q 145 38 144 35 L 144 32 Q 141 31 142 34 L 140 34 L 140 36 Q 137 37 138 34 L 136 35 L 135 33 L 136 31 Q 137 23 135 24 L 135 26 L 135 27 L 134 26 Q 133 23 128 24 L 128 16 Q 132 17 131 15 L 133 15 L 136 15 Q 135 12 134 14 L 132 12 L 132 10 L 132 8 L 121 8 Z M 134 8 L 133 11 L 136 12 L 135 11 L 136 9 L 134 8 Z M 105 10 L 104 16 L 100 16 L 98 16 L 96 20 L 96 22 L 96 24 L 91 24 Q 93 29 89 28 L 90 26 Q 91 23 88 24 L 88 56 L 89 56 L 96 56 L 96 64 L 96 66 L 96 72 L 99 72 L 97 70 L 99 70 Q 101 69 100 72 L 105 71 L 104 73 L 104 76 Q 107 75 106 78 L 104 78 L 104 80 L 111 80 L 113 80 L 118 79 L 120 80 L 121 84 L 120 88 L 125 87 L 130 88 L 132 88 L 145 88 L 146 87 L 148 88 L 157 88 L 156 86 L 158 81 L 158 85 L 158 87 Q 157 89 160 88 Q 158 80 163 77 L 163 79 L 163 80 L 168 80 L 168 72 L 171 72 L 171 70 Q 173 69 172 72 L 176 72 L 176 71 L 174 71 Q 178 67 176 59 L 176 56 L 168 56 L 168 64 L 166 65 L 165 64 L 156 64 L 154 64 L 152 65 L 152 72 L 136 72 L 136 64 L 132 64 L 132 66 L 133 67 L 129 66 L 129 64 L 124 65 L 122 64 L 120 64 L 120 57 L 118 56 L 112 56 L 112 50 L 111 50 L 112 48 L 111 44 L 112 40 L 105 40 L 104 41 L 103 39 L 104 36 L 104 34 L 103 29 L 104 25 L 104 23 L 108 20 L 108 17 L 106 20 Q 103 21 104 19 Q 105 15 110 16 L 109 14 L 105 10 Z M 111 16 L 110 21 L 112 20 L 111 16 Z M 109 22 L 107 24 L 109 24 L 109 22 Z M 65 24 L 64 41 L 61 40 L 56 40 L 56 51 L 56 53 L 56 80 L 59 80 L 59 78 Q 60 81 64 80 L 64 88 L 65 89 L 64 91 L 65 96 L 68 94 L 70 94 L 72 95 L 73 104 L 73 103 L 74 103 L 74 104 L 78 104 L 79 101 Q 81 105 80 112 L 92 112 L 93 111 L 96 112 L 97 116 L 96 119 Q 99 121 107 120 L 108 118 L 108 120 L 120 120 L 120 118 L 125 119 L 128 118 L 127 120 L 124 119 Q 120 122 112 121 L 112 125 L 120 125 L 120 127 L 113 127 L 112 128 L 101 127 L 101 126 Q 105 127 104 124 L 96 125 L 98 125 L 98 126 L 87 124 L 88 121 Q 91 120 93 123 Q 100 124 104 122 L 84 120 L 87 126 L 86 128 L 86 127 L 84 123 L 83 123 L 80 122 L 83 121 L 73 118 L 71 118 L 65 119 L 65 117 L 64 120 L 54 121 L 56 122 L 54 123 L 56 123 L 53 127 Q 54 129 51 128 L 48 134 L 47 132 Q 50 130 48 129 L 50 128 L 50 126 L 49 123 L 43 127 L 39 126 L 37 129 L 32 128 L 32 136 L 34 136 L 35 132 L 37 131 L 36 134 L 36 136 L 35 136 L 35 138 L 33 139 L 32 142 L 33 145 L 32 147 L 33 149 L 33 150 L 24 150 L 24 152 L 24 154 Q 23 156 26 155 L 27 152 L 29 153 L 32 153 L 30 160 L 29 160 L 30 157 L 30 154 L 29 156 L 24 157 L 25 160 L 24 160 L 21 161 L 22 166 L 23 163 L 26 161 L 27 158 L 27 161 L 24 162 L 23 167 L 20 168 L 21 172 L 20 172 Q 21 169 19 170 L 19 172 Q 20 175 18 174 L 17 176 L 20 175 L 21 173 L 21 175 L 21 176 Q 26 178 25 174 L 32 175 L 32 174 L 34 174 L 38 172 L 37 171 L 39 168 L 39 170 L 42 168 L 42 167 Q 39 168 40 165 Q 45 164 43 168 Q 46 169 45 167 L 46 167 Q 45 169 48 168 L 47 167 L 48 165 L 47 158 L 46 155 Q 48 156 47 154 L 48 154 L 47 156 L 48 159 L 51 157 L 52 159 L 53 160 L 85 160 L 87 156 L 88 156 L 87 158 L 87 160 Q 91 158 90 162 L 89 161 L 88 168 L 87 169 L 86 168 L 74 168 Q 71 169 72 174 L 73 176 L 128 176 L 128 181 Q 131 180 130 184 L 133 184 L 133 183 Q 130 184 131 182 L 134 183 L 136 181 Q 135 176 137 176 L 192 176 Q 193 176 192 170 L 191 170 L 189 170 L 189 168 L 167 168 L 165 168 L 152 168 L 152 162 L 150 163 L 148 163 L 150 162 Q 151 159 148 160 L 150 153 L 150 158 Q 147 159 152 161 L 153 160 L 160 160 L 161 158 L 163 159 L 165 156 Q 167 157 166 154 L 171 153 L 171 154 Q 167 153 168 156 L 171 155 Q 173 154 172 157 L 170 157 L 172 160 L 173 160 Q 171 155 175 156 L 174 158 L 176 160 L 189 160 L 191 159 L 190 155 L 187 156 L 188 152 L 189 155 L 190 153 L 193 158 L 208 158 L 208 152 L 201 152 L 200 151 L 198 152 L 196 152 L 193 151 L 193 150 L 199 151 Q 200 148 197 149 L 195 149 Q 190 148 191 151 L 189 151 L 195 147 L 199 148 L 200 149 L 200 145 L 199 147 L 198 147 L 199 144 L 198 142 Q 197 139 200 140 Q 199 135 202 134 L 201 136 L 205 136 L 203 134 L 205 134 L 205 131 L 206 128 L 208 132 L 208 123 L 207 123 L 207 121 L 205 122 Q 203 119 199 120 L 199 122 L 198 121 L 196 120 Q 190 118 192 124 L 192 126 Q 193 129 191 128 L 189 131 L 185 134 L 182 131 L 182 129 L 183 132 L 184 132 L 184 128 L 153 128 Q 150 129 152 131 L 152 132 L 151 131 L 151 129 Q 144 129 141 126 L 139 127 L 136 126 L 132 128 L 128 128 L 134 125 L 137 126 L 143 124 L 143 126 Q 146 127 144 123 L 138 124 Q 135 125 136 122 L 128 121 L 133 120 L 134 118 Q 136 119 134 121 L 137 122 L 144 122 L 139 121 L 143 119 L 147 120 L 149 120 Q 151 121 150 119 L 150 117 L 152 118 L 152 112 L 159 112 L 160 111 L 159 107 L 160 104 L 164 102 L 163 104 L 168 104 L 167 99 L 170 95 L 176 96 L 175 85 L 174 88 L 172 85 L 170 85 L 170 88 L 160 88 L 160 95 L 161 96 L 153 96 L 152 97 L 150 96 Q 144 95 143 97 L 140 96 L 105 96 L 103 95 L 104 93 L 103 93 L 102 91 L 102 88 L 96 88 L 96 87 Q 97 81 94 80 Q 89 79 88 82 L 88 81 Q 89 76 87 75 L 88 73 L 86 72 L 80 72 L 80 63 L 80 61 L 80 53 L 79 52 L 80 49 L 80 31 L 79 30 L 80 24 L 67 24 L 66 26 L 68 27 L 67 27 L 65 24 Z M 137 32 L 137 33 L 140 33 L 137 32 Z M 175 45 L 174 48 L 175 48 L 175 45 Z M 170 80 L 169 83 L 170 83 L 170 80 Z M 173 81 Q 170 85 174 84 L 173 81 Z M 69 112 L 69 113 L 77 113 L 69 112 Z M 70 114 L 70 115 L 72 115 L 70 114 Z M 74 115 L 76 117 Q 77 114 74 115 Z M 66 116 L 66 117 L 72 117 L 66 116 Z M 35 120 Q 34 122 37 121 L 35 125 Q 31 124 32 127 L 36 127 L 39 125 L 38 122 L 44 121 L 35 120 Z M 48 120 L 49 122 Q 51 121 50 124 Q 53 125 52 122 L 54 122 L 52 120 L 50 121 L 48 120 Z M 32 121 Q 31 124 34 123 Q 35 120 32 121 Z M 41 122 L 40 125 L 44 125 L 45 123 L 41 122 Z M 54 123 L 52 126 L 54 125 L 54 123 Z M 188 128 L 187 130 L 189 129 L 188 128 Z M 207 132 L 206 134 L 208 135 L 207 132 Z M 24 144 L 25 146 L 32 146 L 32 144 L 24 144 Z M 166 156 L 165 159 Q 164 161 167 160 L 168 157 L 166 156 Z M 19 160 Q 16 162 17 168 Q 19 171 20 168 Q 21 161 19 160 Z M 72 162 L 72 166 L 80 166 L 80 162 L 72 162 Z M 48 168 L 48 176 L 64 176 L 64 168 L 48 168 Z M 40 171 L 37 173 L 37 175 L 35 176 L 40 176 L 40 171 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 26 L 132 27.5 L 130 28.5 L 131.5 26 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 33 L 68 34.5 L 66 35.5 L 67.5 33 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 36 L 90 39.5 L 89 39.5 L 89.5 36 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 36 L 93 39.5 L 92 39.5 L 91.5 36 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 37 L 122.5 39 L 121.5 37 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 40 L 75 47.5 L 73.5 50 L 73 48.5 L 74.5 40 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77 40 L 79 40.5 L 79 48 L 77 47.5 L 77 40 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 40 L 122 42 Q 124.7 43.1 124 40.5 L 125 40.5 L 123.5 43 Q 121.3 42.3 122 44.5 L 121 44.5 L 121.5 40 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 41 L 108 44 L 106 44.5 L 107 47.5 L 106 47.5 L 105 44.5 L 106.5 41 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 42 L 160 42.5 L 152.5 43 L 152.5 42 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 43 L 126 44.5 Q 126.8 46.8 124.5 46 L 126.5 43 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 48 L 91.5 50 Q 89.3 49.3 90 51.5 L 89 51.5 L 90.5 48 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 49 L 78 51.5 L 77 51.5 L 77.5 49 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 50 L 76 52.5 L 75 52.5 L 75.5 50 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 53 L 158 53.5 L 153.5 54 L 153.5 53 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 57 L 79 58.5 L 77.5 61 L 77 59.5 L 78.5 57 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 57 L 171.5 59 L 172.5 57 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 58 L 60 63.5 L 59 63.5 L 59.5 58 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 61 L 97.5 63 L 98.5 61 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 66 L 171.5 68 L 172.5 66 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 74 Q 59.6 76.8 63 76 L 64 78.5 L 62.5 78 Q 59.2 79.1 60 76.5 L 58.5 74 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 76 L 87 78.5 L 86 78.5 L 86.5 76 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 81 L 154.5 83 L 155.5 81 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 82 L 150 83.5 L 148.5 87 L 147.5 85 Q 149.8 85.8 149 83.5 L 150.5 82 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 84 Q 133.8 83.3 133 85.5 L 131.5 84 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 85 L 144 85.5 L 139.5 86 L 139.5 85 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 86 L 155 86.5 L 152.5 87 L 152.5 86 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 97 L 128 97.5 L 124.5 98 L 124.5 97 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 97 L 148.5 99 L 147.5 97 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 98 L 134 98.5 L 129.5 99 L 129.5 98 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120 99 L 127 100.5 L 123.5 102 L 120 101 L 120 99 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 101 L 76.5 103 L 75.5 101 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 101 L 144 101.5 L 141.5 102 L 141.5 101 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 106 L 85.5 108 L 84.5 106 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 109 Q 86.8 108.3 86 110.5 L 84.5 109 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 109 L 90.5 111 L 89.5 109 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 117 L 100.5 119 L 101.5 117 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 122 Q 133.3 121.3 135 123.5 L 130.5 124 L 128.5 122 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 126 L 91 127.5 L 88 128 L 88 126 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 130 L 123 131.5 L 122 134.5 Q 122.8 136.8 120.5 136 L 120 133.5 L 121 131.5 L 120.5 130 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64 131 L 71.5 131 L 73 132.5 L 73.5 135 L 75 134.5 L 72 135.5 L 73 143.5 L 72 146 L 64.5 146 L 64 144 L 72 144 L 72 141 L 64 141 L 64 135 L 67 134.5 L 63 133.5 L 64 131 Z M 66 132 L 66 133 L 72 133 L 66 132 Z M 71 134 L 70 136 L 72 135 L 71 134 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 132 L 88 133.5 L 89 136.5 L 88 136.5 L 87 133.5 L 88.5 132 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 132 L 109 136 L 105 137 L 105.5 139 L 107 138.5 L 107 141 Q 104.3 139.9 105 142.5 L 104 142.5 L 105 139.5 L 103 135.5 L 104.5 136 L 107 135.5 L 107 133.5 L 107.5 132 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 135 L 62 137.5 L 59.5 139 L 61 136.5 L 61.5 135 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 136 L 48 138.5 L 46.5 138 L 45 137.5 L 46.5 136 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100 136 Q 103.5 134.9 102 142.5 L 101 142.5 L 100.5 140 L 99.5 144 L 99 140.5 L 100 136 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 136 Q 153.8 135.3 153 137.5 L 151.5 136 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 136 L 187 137.5 L 184.5 139 L 184.5 138 Q 187 138.7 186.5 136 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 137 L 136 138.5 L 134.5 139 L 133.5 137 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137 137 L 139 137.5 L 137 138.5 L 137 137 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164 137 Q 167 135.8 166 139.5 L 165.5 142 Q 162.2 143.1 163 140.5 L 164 137 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 138 L 89 141.5 L 88 141.5 L 88.5 138 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 139 L 153 141.5 L 151 140.5 L 151.5 139 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 140 Q 172.3 139 171 142 L 168.5 140 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 143 L 152 145.5 L 151.5 147 L 150 146.5 L 147.5 152 L 148 150.5 L 151.5 143 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 143 Q 167.3 144.3 166 149.5 L 165 149.5 L 164.5 143 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 143 L 174 144 L 175 146.5 L 173 147.5 L 174 150 L 170 149 L 168.5 143 Z M 171 145 L 173 147 Q 174 144 171 145 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 144 L 46 148 Q 43 149.3 44 145.5 L 45.5 144 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 144 L 88 146.5 L 88 148.5 Q 89.3 152.3 85.5 151 L 85.5 150 L 87 149.5 L 85 148.5 L 86 146.5 L 85.5 145 L 87.5 144 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 144 L 195 146 L 192.5 147 L 194.5 144 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 147 L 63.5 148 Q 65.3 145.3 71.5 147 L 71.5 148 Q 64.3 146.3 62.5 150 L 62.5 148 L 61.5 147 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 147 Q 103.3 146 102 149 L 100 149.5 L 100.5 151 Q 98.3 151.8 99 149.5 L 99.5 147 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167 147 L 169 147.5 L 168 148.5 L 170.5 152 L 167 151 L 167 147 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134 148 L 143.5 148 L 146 149.5 L 136.5 150 L 134 149.5 L 134 148 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 149 L 46 152.5 L 44.5 152 Q 41.4 152.7 43.5 149 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 151 Q 177.3 152.3 175 153.5 Q 175.7 156.1 173 155 L 172 152.5 L 173.5 153 L 175 152.5 L 174.5 151 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 152 L 119 158.5 L 118 158.5 L 116.5 156 Q 113.9 156.8 115 153.5 L 116.5 152 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162 152 Q 164.7 150.9 164 153.5 L 163 156 L 160.5 157 L 160 155.5 L 162 152 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 153 L 148 155.5 L 147 155.5 L 147.5 153 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 160 Q 45.8 158.9 45 161.5 L 46 165 Q 42.7 166.3 44 161.5 L 42 162.5 L 41.5 164 L 41 161.5 L 42.5 160 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120 160 L 130.5 160 L 131 161.5 Q 127.8 163 129 168 L 120 168 L 120 163 Q 114.8 164.7 116 161 L 120 162 L 120 160 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 160 L 136 163.5 L 135 163.5 L 135.5 160 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 160 L 139 162.5 L 137 161.5 L 137.5 160 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 161 Q 100.8 159.9 100 162.5 L 103 166.5 L 99.5 164 L 98 164.5 L 99 162 L 97.5 161 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 161 L 107 161.5 L 104.5 162 L 104.5 161 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 162 L 103.5 164 L 102.5 162 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 18.5 163 L 19 166.5 L 18 166.5 L 18.5 163 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 163 L 97 163.5 L 94.5 164 L 94.5 163 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105 164 L 108 164.5 L 106 165 L 105.5 167 L 105 164 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 165 L 134 168 L 131.5 169 L 132 167.5 L 133.5 165 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89 166 L 91 166.5 L 89 167.5 L 89 166 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 169 L 136 169.5 L 133.5 170 L 133.5 169 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 171 Q 137.8 170.3 137 172.5 L 135.5 171 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126 8 L 128 8.5 L 126 9.5 L 126 8 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 9 L 125 12.5 L 123 11.5 L 124.5 9 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 13 L 121 15.5 L 120 15.5 L 120.5 13 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 26 L 95 27.5 L 93 28.5 L 94.5 26 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 29 L 103 32.5 L 102 32.5 L 102.5 29 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 30 L 93 34.5 L 92 34.5 L 91.5 30 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75 32 L 77 32.5 L 75 33.5 L 75 32 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 32 L 134.5 34 L 133.5 32 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 35 L 65.5 37 L 64.5 35 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 37 L 89 39.5 L 88 39.5 L 88.5 37 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 37 L 123.5 39 L 122.5 37 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 39 L 75 39.5 L 72.5 40 L 72.5 39 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141 39 L 144 39.5 L 141.5 41 L 141 39 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 42 L 150.5 44 L 148 43.5 L 151.5 42 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 46 L 57.5 48 L 56.5 46 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 46 L 94 48.5 L 92 47.5 L 92.5 46 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 46 L 110 51.5 L 109 51.5 Q 106 49.7 107.5 46 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 47 L 171 47.5 L 168.5 48 L 168.5 47 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 50 L 97 56.5 L 95.5 56 Q 91.3 57.3 93 52.5 L 92.5 50 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 52 L 146 54.5 L 142.5 55 L 139.5 52 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 54 L 77.5 56 Q 75.3 55.3 76 57.5 L 75 57.5 L 76.5 54 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 56 L 116.5 58 L 117.5 56 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 56 L 175 56.5 Q 172.9 59.8 172.5 56 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 59 L 77 62.5 L 76 62.5 L 76.5 59 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 61 L 169 63.5 L 168 63.5 L 168.5 61 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 65 L 79 67.5 L 77 66.5 L 78.5 65 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 66 L 132 67.5 L 130.5 67 L 129.5 66 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 67 L 108 73.5 Q 107.3 75.8 109.5 75 L 109.5 76 L 107 74.5 L 103.5 70 L 100.5 67 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 67 L 136 69 L 133 68.5 L 135.5 67 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 68 L 156.5 70 L 153.5 72 L 155 69.5 L 155.5 68 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 72 Q 86.8 71.3 86 73.5 L 84.5 72 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 74 L 84.5 76 Q 81.7 76.7 83.5 74 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 74 L 168 74.5 L 165.5 76 L 166.5 74 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 78 L 117 79.5 L 115.5 80 L 114.5 78 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 82 L 157 82.5 L 154.5 84 L 155.5 82 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 84 L 148 84.5 L 144.5 85 L 144.5 84 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 87 L 95.5 89 L 94.5 87 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 88 L 69 90.5 L 68 90.5 L 68.5 88 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 89 L 176 90.5 L 174.5 90 L 173.5 89 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 91 L 163.5 93 L 162 92.5 L 164.5 91 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 91 L 173 91.5 L 171.5 94 Q 168.5 92.5 171.5 91 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 92 Q 71.8 91.3 71 93.5 L 69.5 92 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 100 Q 144.3 99.3 145 101.5 L 143.5 101 Q 139.5 101.8 140.5 100 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 102 L 167.5 104 L 166.5 102 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82 106 L 85 107.5 L 82 107.5 L 82 106 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 114 L 149.5 117 L 146 115.5 L 149.5 114 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 117 L 144.5 120 L 142.5 117 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 119 L 132 119.5 L 128.5 120 L 128.5 119 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 121 L 195.5 123 L 196.5 121 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 127 L 120 127.5 L 112.5 128 L 112.5 127 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 128 L 153 129 L 152.5 131 L 150.5 128 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 132 L 152.5 134 Q 149.7 134.7 151.5 132 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 134 L 204.5 136 L 203.5 134 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 135 L 185.5 137 Q 182.7 137.7 184.5 135 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 143 L 60.5 145 Q 57.7 145.7 59.5 143 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 144 L 62.5 146 L 63.5 144 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 146 L 62 148.5 L 60 147.5 L 60.5 146 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 147 L 119 147.5 Q 116.9 150.8 116.5 147 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 157 L 45 159.5 L 44 159.5 L 44.5 157 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 160 L 111 160.5 L 108.5 161 L 108.5 160 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 163 Q 95.5 164.5 92.5 166 L 92.5 163 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 163 L 111.5 165 L 112.5 163 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 163 L 143 165 L 141 164.5 L 142.5 163 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 163 L 146.5 165 Q 143.7 165.7 145.5 163 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 171 L 155 173 L 153 172.5 L 154.5 171 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,247)",
    stroke: "rgb(252,251,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 172 L 188 174.5 L 187 174.5 L 186.5 172 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 17 L 108 19.5 L 107 19.5 L 107.5 17 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 30 L 65.5 32 L 66.5 30 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 31 L 78.5 33 L 79.5 31 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 32 L 171 34 L 168 33.5 L 170.5 32 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 40 L 173.5 42 L 174.5 40 L 175 41.5 L 174 44.5 L 174.5 46 L 173 45.5 L 172.5 48 L 172 45.5 L 173 42.5 L 172.5 40 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 43 L 92 46.5 L 91 46.5 L 91.5 43 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 43 L 158 43.5 L 154.5 44 L 154.5 43 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 44 L 107.5 46 L 106.5 44 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 49 L 79 52.5 L 78 52.5 L 78.5 49 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 50 L 77 52.5 L 76 52.5 L 76.5 50 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 50 L 166.5 52 L 167.5 50 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 84 L 143 84.5 L 140.5 85 L 140.5 84 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 88 L 161.5 90 L 160.5 88 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 93 L 70 95.5 L 68 94.5 L 68.5 93 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 118 L 74.5 120 L 73.5 118 Z "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 121 L 132 121.5 L 128.5 122 L 128.5 121 Z "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 121 L 143 121.5 L 140.5 122 L 140.5 121 Z "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42 122 L 44 122.5 L 42 123.5 L 42 122 Z "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 123 L 142 123.5 L 139.5 124 L 139.5 123 Z "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 124 L 48.5 126 Q 45.7 126.7 47.5 124 Z "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33 125 Q 36 124 35 127 Q 32 128 33 125 Z "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192 125 L 194 125.5 L 192 130 Q 189 131 190 128 Q 193.3 129.1 192 125 Z "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 126 L 96 126.5 L 92.5 128 L 93.5 126 Z "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 181.5 128 L 182.5 130 L 181.5 128 Z "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 187.5 128 L 186.5 130 L 187.5 128 Z "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 207.5 130 L 208 131.5 L 206 132.5 L 207.5 130 Z "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 137 L 153 139.5 L 152 139.5 L 151.5 137 Z "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 138 L 172 140.5 L 170 139.5 L 170.5 138 Z "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 141 L 101 143.5 L 100 143.5 L 100.5 141 Z "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 142 L 152.5 144 L 151.5 142 Z "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 144 L 196 146.5 L 195 146.5 L 195.5 144 Z "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 145 L 173.5 148 L 171 147 L 171.5 145 Z "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 146 L 63.5 148 L 62.5 146 Z "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 148 L 102 149 L 101.5 151 L 99.5 148 Z "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 149 L 84.5 151 L 85.5 149 Z "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 149 L 196 149.5 L 193.5 150 L 193.5 149 Z "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 150 L 148 150.5 L 144.5 151 L 144.5 150 Z "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 151 L 174.5 153 L 175.5 151 Z "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 152 L 165 154.5 L 164 154.5 L 164.5 152 Z "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 152 L 173 153.5 L 171.5 154 L 168.5 153 L 168.5 152 Z "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 154 L 30 156.5 L 29 156.5 L 29.5 154 Z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 156 L 173 158.5 L 171 157.5 L 172.5 156 Z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 157 L 29 159.5 L 27 158.5 L 27.5 157 Z "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132 160 Q 134.7 158.9 134 161.5 L 132 162.5 L 132 160 Z "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 161 L 44 163.5 L 40.5 165 L 40.5 164 L 43 162.5 L 43.5 161 Z "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19.5 162 L 20 164.5 L 19 164.5 L 19.5 162 Z "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 162 Q 99.8 161.3 99 163.5 L 99.5 165 L 97.5 162 Z "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 17.5 163 L 19 168.5 L 16 168.5 L 17.5 163 Z "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46 163 L 48 163.5 L 46.5 166 L 46 163 Z "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 166 L 43.5 168 L 44.5 166 Z "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(252,251,250)",
    stroke: "rgb(252,251,250)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 183 L 133 183.5 L 130.5 184 L 130.5 183 Z "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 8 L 130 10.5 L 128 11.5 L 129 9.5 L 128.5 8 Z "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 40 L 73 47.5 L 72 47.5 L 72.5 40 Z "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 41 L 156 41.5 L 152.5 42 L 152.5 41 Z "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166 54 L 168 54.5 L 166 55.5 L 166 54 Z "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 57 L 119.5 60 L 117.5 57 Z "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 59 L 59 61.5 L 58 61.5 L 58.5 59 Z "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 65 L 156.5 67 Q 153.7 67.7 155.5 65 Z "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 66 L 153.5 68 L 152.5 66 Z "
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 69 L 100.5 71 L 99.5 69 Z "
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 80 L 91.5 82 L 92.5 80 Z "
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 92 L 102.5 94 L 103.5 92 Z "
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 120 L 195 120.5 Q 192.9 123.8 192.5 120 Z "
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52 124 L 54.5 125 L 56 124.5 L 53.5 127 L 51 126.5 L 52 124 Z "
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 124 L 85.5 126 L 84.5 124 Z "
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 128 L 120.5 130 L 121.5 128 Z "
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 133 L 122.5 135 L 121.5 133 Z "
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 138 L 63.5 140 Q 60.7 140.7 62.5 138 Z "
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 141 L 172.5 143 L 173.5 141 Z "
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 148 L 131.5 150 L 130.5 148 Z "
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 148 Q 163.8 147.3 163 149.5 L 161.5 148 Z "
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 150 L 72 150.5 L 63.5 151 L 63.5 150 Z "
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 155 L 85.5 157 L 86.5 155 Z "
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(249,251,252)",
    stroke: "rgb(249,251,252)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 172 L 36.5 174 L 34 173.5 L 35.5 172 Z "
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 10 L 128 13 L 126 13.5 L 127 14.5 L 127 23.5 L 126 23.5 L 126 14.5 L 125 13.5 L 127.5 10 Z "
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 15 L 105 16.5 L 104 19 L 102 19.5 L 103 22.5 L 102 22.5 L 101 19.5 L 104.5 15 Z "
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 15 L 124 16.5 L 123.5 18 L 123 16.5 L 124.5 15 Z "
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 21 L 99.5 23 L 100.5 21 Z "
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 22 L 122 28.5 L 121 28.5 L 121.5 22 Z "
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 24 L 97.5 26 L 98.5 24 Z "
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 24 L 102 27.5 L 101 27.5 L 101.5 24 Z "
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 25 L 76 28 L 74 28.5 L 74.5 30 L 73.5 29 L 71 30.5 L 75.5 25 Z "
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 27 L 97 28.5 L 95.5 31 L 95 29.5 L 96.5 27 Z "
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 28 Q 131.4 35.6 137.5 40 L 140 41.5 L 138.5 41 L 131 34.5 L 128 29.5 L 128.5 28 Z "
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 31 L 74 33.5 L 73 33.5 L 73.5 31 Z "
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 32 L 69 34.5 L 66.5 38 L 68 35.5 L 70.5 32 Z "
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 33 L 95 35.5 L 94 35.5 L 94.5 33 Z "
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 34 L 102 37.5 L 101 37.5 L 101.5 34 Z "
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 34 L 126 38.5 L 124 37.5 L 123.5 34 Z "
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 39 L 94 42.5 L 93 42.5 L 93.5 39 Z "
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 39 L 170 40.5 L 168.5 43 L 168 41.5 L 170.5 39 Z "
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 40 L 72 49.5 L 71 49.5 L 71.5 40 Z "
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 40 L 136 48.5 L 134.5 48 L 126.5 40 Z "
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 42 L 164.5 45 L 163 44.5 L 166.5 42 Z "
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 44 L 163.5 49 L 159.5 51 L 159.5 50 L 167.5 44 Z "
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 45 L 153 45.5 L 148.5 46 L 148.5 45 Z "
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 45 L 162 45.5 L 158.5 46 L 158.5 45 Z "
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 46 L 95 49.5 L 94 49.5 L 94.5 46 Z "
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 46 L 157 46.5 L 154.5 47 L 154.5 46 Z "
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 47 L 63 49.5 L 62 49.5 L 62.5 47 Z "
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 48 L 108 51.5 L 106 50.5 L 105.5 48 Z "
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 50 L 143 51.5 L 141.5 52 L 139.5 50 Z "
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 51 L 158 51.5 L 154.5 52 L 154.5 51 Z "
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 52 L 62 57.5 L 61 57.5 L 61.5 52 Z "
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 52 L 153 52.5 L 146.5 53 L 146.5 52 Z "
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 53 L 110.5 56 L 108.5 53 Z "
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 54 L 73 56.5 L 72 56.5 L 72.5 54 Z "
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 54 Q 101.4 67.1 112 74.5 L 101 64.5 L 96 55.5 L 96.5 54 Z "
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 57 L 115.5 62 L 111.5 57 Z "
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 58 L 76 65.5 L 75 65.5 L 73.5 58 Z "
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 59 L 174 60.5 Q 170.5 70.5 162.5 76 L 169 68.5 L 171 64.5 L 168.5 66 L 165.5 68 L 167.5 65 L 172 61.5 L 173.5 59 Z "
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 60 L 62 65.5 L 61 65.5 L 61.5 60 Z "
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 62 L 123 66.5 L 120.5 65 L 117.5 62 Z "
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 68 L 63 70.5 L 62 70.5 L 62.5 68 Z "
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 68 L 132 70.5 L 130.5 71 Q 126.5 70.5 126.5 68 Z "
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 68 L 162.5 70 L 156.5 72 L 156.5 71 L 163.5 68 Z "
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 71 L 81 74.5 L 79 73.5 L 78.5 71 Z "
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 71 L 136 71.5 L 133.5 72 L 133.5 71 Z "
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 72 L 66 79.5 L 65 79.5 L 63.5 72 Z "
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 72 L 140 72.5 L 137.5 73 L 137.5 72 Z "
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 72 L 154 72.5 L 150.5 73 L 150.5 72 Z "
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 75 L 114.5 77 L 113.5 75 Z "
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 76 L 82.5 78 L 81.5 76 Z "
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 76 L 159.5 78 L 160.5 76 Z "
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 79 L 101 94.5 L 99.5 94 Q 88.8 88.5 83.5 79 Z "
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 79 L 127 81.5 L 124.5 82 L 120.5 80 L 120.5 79 Z "
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 80 L 154 80.5 L 148.5 82 L 148.5 81 L 152.5 80 Z "
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 82 L 134 82.5 L 128.5 83 L 128.5 82 Z "
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 82 L 147 82.5 L 142.5 83 L 142.5 82 Z "
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 87 L 73 91.5 L 70 89.5 L 69.5 87 Z "
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 88 L 171 89.5 L 167.5 95 L 168 93.5 L 167.5 92 L 161.5 97 L 163.5 94 L 170.5 88 Z "
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 93 L 77 98 Q 79.7 96.9 79 99.5 L 96 111.5 L 94.5 112 Q 83.8 106.2 76 97.5 L 73.5 93 Z "
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 95 L 109 98.5 L 107.5 99 Q 102.9 97.8 102.5 95 Z "
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 96 L 164.5 99 L 166.5 96 Z "
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 97 L 158.5 99 L 155.5 100 L 155.5 99 L 159.5 97 Z "
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 101 L 152 101.5 L 146.5 103 L 146.5 102 L 149.5 101 Z "
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 101 L 157.5 107 L 145.5 114 L 145.5 113 Q 156 109 162.5 101 Z "
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 102 L 121 102.5 L 118.5 103 L 118.5 102 Z "
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 103 L 130 103.5 L 122.5 104 L 122.5 103 Z "
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 103 L 145 103.5 L 138.5 104 L 138.5 103 Z "
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 104 L 136 104.5 L 131.5 105 L 131.5 104 Z "
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 112 L 100 113.5 L 98.5 114 L 97.5 112 Z "
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 114 L 110 116.5 L 106.5 117 L 101.5 115 L 101.5 114 Z "
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 114 L 144 114.5 L 139.5 116 L 139.5 115 L 142.5 114 Z "
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 116 L 138 116.5 L 135.5 117 L 135.5 116 Z "
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 117 L 117 117.5 L 112.5 118 L 112.5 117 Z "
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 117 L 134 117.5 L 128.5 118 L 128.5 117 Z "
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 119 L 72 119.5 L 68.5 120 L 68.5 119 Z "
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 122 L 83.5 126 L 80.5 122 Z "
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 123 L 53.5 128 L 57.5 123 Z "
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 123 L 207.5 123 L 208 124.5 L 206.5 124 L 197.5 124 L 196.5 125 L 197.5 123 Z "
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 126 L 204.5 129 L 206.5 126 Z "
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 127 L 141 127.5 L 134.5 128 L 134.5 127 Z "
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 128 L 72 128.5 L 66.5 129 L 66.5 128 Z "
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 128 L 120 131.5 L 119 131.5 L 119.5 128 Z "
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 129 L 38 131.5 L 37 131.5 L 37.5 129 Z "
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 129 L 76 132.5 L 75 132.5 L 73.5 129 Z "
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 129 L 148.5 132 L 146.5 129 Z "
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 130 L 111 132.5 L 110 132.5 L 110.5 130 Z "
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 130 L 123.5 134 L 126.5 130 Z "
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 130 L 191.5 132 L 192.5 130 Z "
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 130 L 202.5 132 L 203.5 130 Z "
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 131 L 156 133.5 L 155 133.5 L 155.5 131 Z "
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 190.5 133 L 189.5 135 L 190.5 133 Z "
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 134 L 198.5 137 L 200.5 134 Z "
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 135 L 91 137.5 L 90 137.5 L 90.5 135 Z "
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 135 L 100 137.5 L 99 137.5 L 99.5 135 Z "
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 135 L 138 135.5 L 135.5 136 L 135.5 135 Z "
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 136 L 141 139.5 L 140 139.5 L 139.5 136 Z "
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163 136 L 173.5 136 L 174.5 137 L 177.5 136 L 179.5 136 L 183 137.5 L 174 138 L 173.5 141 L 173 138.5 L 173.5 137 L 164.5 137 L 163.5 138 L 163 136 Z "
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 136 L 187.5 138 L 188.5 136 Z "
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 137 L 45 137.5 L 36 138 L 35.5 140 L 35 138.5 L 36.5 137 Z "
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 138 L 195.5 141 L 197.5 138 Z "
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 139 L 109 141.5 L 108 141.5 L 108.5 139 Z "
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 139 L 185.5 141 L 186.5 139 Z "
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 140 L 45 142.5 L 44 142.5 L 44.5 140 Z "
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 140 L 99 142.5 L 98 142.5 L 98.5 140 Z "
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 140 L 150 143.5 L 149 143.5 L 149.5 140 Z "
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 142 L 192.5 145 L 194.5 142 Z "
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 143 L 48 147.5 L 47 147.5 L 47.5 143 Z "
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 143 L 117 145.5 L 116 145.5 L 116.5 143 Z "
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 145 L 89 153.5 L 88 153.5 L 88.5 145 Z "
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 145 L 98 149.5 L 97 149.5 L 97.5 145 Z "
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 145 L 153 147.5 L 152 147.5 L 152.5 145 Z "
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 146 L 189.5 149 L 191.5 146 Z "
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 147 L 60.5 150 L 62 150.5 L 60.5 151 Q 56.9 149.9 58.5 147 Z "
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 149 L 43 151.5 L 42 151.5 L 42.5 149 Z "
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 149 L 107 150.5 Q 105.5 153.5 99.5 152 L 99.5 151 Q 106.8 152.5 106.5 149 Z "
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 149 L 129.5 151 L 128.5 149 Z "
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 149 L 161 151.5 L 160 151.5 L 160.5 149 Z "
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 150 L 86 151 L 85.5 154 L 85 152 Q 81.2 152.8 81.5 150 Z "
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 150 L 187.5 152 L 188.5 150 Z "
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 151 L 145.5 151 L 147 152.5 L 146.5 156 L 146 152 L 131.5 152 L 131.5 151 Z "
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 154 L 42 156.5 L 41 156.5 L 41.5 154 Z "
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 154 L 151 156.5 L 150 156.5 L 150.5 154 Z "
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 154 L 160 156.5 L 159 156.5 L 159.5 154 Z "
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 155 L 56 158.5 L 54.5 159 L 50.5 155 Z "
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 157 L 114 158.5 L 112.5 160 L 94.5 160 L 94.5 159 L 112.5 159 L 113.5 157 Z "
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 157 L 176 159 L 184.5 159 L 185 157.5 L 186 157.5 L 184.5 160 L 175.5 160 L 175.5 157 Z "
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 159 L 61 159.5 L 57.5 160 L 57.5 159 Z "
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 159 L 84 159.5 L 76.5 160 L 76.5 159 Z "
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 159 L 159 159.5 L 150.5 160 L 150.5 159 Z "
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 162 L 28.5 164 L 25 163.5 L 29.5 162 Z "
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 165 L 24 167.5 L 23 167.5 L 23.5 165 Z "
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93 166 L 96.5 168 L 99 167 L 100.5 170 L 102 169.5 L 98 171 L 98.5 174 L 99.5 172 L 100 175 L 105 174.5 L 101 173.5 L 105.5 172 L 106 174.5 L 104.5 176 L 99.5 175 L 96.5 176 L 94 172.5 L 93 166 Z M 98 168 L 95 172 L 96 175 L 98 175 L 97 172 Q 101 170 98 168 Z "
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 166 L 113 166.5 L 110.5 167 L 110.5 166 Z "
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 166 Q 146.5 165.1 145 169.5 L 147 169.5 L 147 171.5 Q 146.3 173.8 148.5 173 L 148.5 174 Q 144.8 175.3 146 171.5 L 145 171.5 Q 143.3 176.8 148.5 175 L 148.5 176 L 143.5 175 L 138.5 176 L 137 172.5 L 138 172.5 L 138 175 L 143 175 Q 142.3 171.6 145 170.5 L 143.5 166 Z "
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 168 L 35.5 171 L 37.5 168 Z "
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 168 L 111 170.5 L 110 170.5 L 110.5 168 Z "
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 168 L 113.5 170 L 115 169.5 L 110.5 176 L 109.5 174 L 111 174.5 L 112.5 168 Z "
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79 169 L 81 169.5 L 79.5 172 L 79 169 Z "
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 169 L 86.5 169 L 88 169.5 L 86.5 173 L 84.5 169 Z "
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 169 L 93 172.5 L 91 171.5 L 91.5 169 Z "
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 169 L 121 169.5 L 120 173 L 123 173.5 L 120 174.5 L 123 175.5 L 119.5 176 L 117.5 176 L 113 175.5 L 117 174.5 L 114 173.5 L 119 171.5 L 118.5 169 Z "
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 169 L 130.5 170 L 132 169.5 L 130.5 172 Q 127.2 173.1 128 170.5 L 126 171.5 L 129 173.5 L 126 174.5 L 130 175 Q 128.8 172 132.5 173 L 134 175.5 L 131 177 L 130.5 175 L 125.5 176 L 124 172 Q 121 173 122 170 L 126.5 169 Z "
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 169 L 138.5 171 L 139.5 169 Z "
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 169 L 156 171.5 L 155 171.5 L 155.5 169 Z "
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 169 L 165 172.5 Q 162.8 173.8 165.5 175 Q 169.3 175.8 170 173.5 L 169 169.5 L 172 171.5 L 168.5 176 Q 163.8 176.8 163 173.5 L 163.5 169 Z "
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 169 L 179.5 170 Q 182.1 169.3 181 172 Q 178.3 173.1 179 170.5 L 177 171.5 L 176.5 175 L 176 172 L 173.5 173 L 173 171 Q 176.8 172.3 176.5 169 Z "
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 170 L 104 172 L 102 171.5 L 103.5 170 Z "
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 170 L 117 172 L 115 171.5 L 116.5 170 Z "
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 170 L 169 172.5 L 166.5 174 L 166.5 173 Q 168.8 173.8 168 171.5 L 166 171.5 L 167.5 170 Z "
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 171 L 90 171.5 L 88 172.5 L 88 171 Z "
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 171 Q 160.1 170.2 159 173.5 L 160 176 L 158 175.5 L 158 173.5 L 157.5 171 Z "
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160 171 Q 163.3 169.7 162 174.5 L 162.5 176 Q 159.9 176.8 161 173.5 L 160 171 Z "
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 172 L 142 173.5 L 140.5 174 L 139.5 172 Z "
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 172 L 186 174.5 L 183.5 176 L 181.5 176 L 178 175.5 L 181 174.5 L 179 173.5 L 180.5 173 L 182.5 174 L 182.5 172 Z "
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80 173 L 84 175 L 84.5 173 L 85 174.5 L 81.5 176 L 79.5 176 L 77 175.5 L 80 175 L 80 173 Z "
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 173 L 157 174.5 Q 155.5 177.5 154 174.5 L 156 174.5 L 156.5 173 Z "
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 174 L 88 176 L 86 175.5 L 87.5 174 Z "
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,200,219)",
    stroke: "rgb(176,200,219)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 174 L 94 176 L 92 175.5 L 93.5 174 Z "
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 11 L 125.5 13 L 126.5 11 Z "
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 17 L 101.5 19 L 102.5 17 Z "
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 20 L 99.5 22 L 100.5 20 Z "
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 26 L 72.5 29 L 74.5 26 Z "
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 28 L 102 33.5 L 101 33.5 L 101.5 28 Z "
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 30 L 95 32.5 L 94 32.5 L 94.5 30 Z "
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 31 L 68.5 34 L 70.5 31 Z "
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 34 L 137.5 40 L 132.5 34 Z "
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 36 L 94 38.5 L 93 38.5 L 93.5 36 Z "
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 39 L 170.5 41 L 171.5 39 Z "
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 41 L 128.5 44 L 126.5 41 Z "
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 42 L 64 43.5 L 62.5 47 L 62 44.5 L 63.5 42 Z "
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 42 L 168.5 44 L 169.5 42 Z "
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 43 L 94 45.5 L 93 45.5 L 93.5 43 Z "
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 43 L 165 43.5 L 161.5 45 L 161.5 44 L 163.5 43 Z "
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 45 L 107 48.5 L 105 47.5 L 104.5 45 Z "
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 45 L 131.5 47 L 130.5 45 Z "
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 45 L 158 45.5 L 153.5 46 L 153.5 45 Z "
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 48 L 62 51.5 L 61 51.5 L 61.5 48 Z "
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 49 L 139 50.5 L 137.5 51 L 135.5 49 Z "
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 52 L 110.5 55 L 108.5 52 Z "
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 52 L 146 52.5 L 143.5 53 L 143.5 52 Z "
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 52 L 157 52.5 L 153.5 53 L 153.5 52 Z "
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 55 L 74 57.5 L 73 57.5 L 73.5 55 Z "
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 56 L 114 57 L 117 61.5 L 111.5 56 Z "
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 61 L 168.5 65 L 171.5 61 Z "
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 61 L 174 63.5 L 172 64.5 L 173.5 61 Z "
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 65 L 123.5 67 L 122.5 65 Z "
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 66 L 62 69.5 L 61 69.5 L 61.5 66 Z "
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 66 L 109.5 74 L 102.5 66 Z "
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 68 L 163 68.5 L 159.5 70 L 159.5 69 L 161.5 68 Z "
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 71 L 63 73.5 L 62 73.5 L 62.5 71 Z "
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 72 L 143 72.5 L 140.5 73 L 140.5 72 Z "
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 72 L 150 72.5 L 144.5 73 L 144.5 72 Z "
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 72 L 163.5 76 L 166.5 72 Z "
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 75 L 82.5 77 L 81.5 75 Z "
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 75 L 113.5 77 L 112.5 75 Z "
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 76 L 160.5 78 L 161.5 76 Z "
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 78 L 87.5 83 L 83.5 78 Z "
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 80 L 67 82.5 L 65 81.5 L 65.5 80 Z "
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 80 L 124 81.5 L 122.5 82 L 121.5 80 Z "
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 80 L 153.5 82 L 152 81.5 L 154.5 80 Z "
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 82 L 150 82.5 L 147.5 83 L 147.5 82 Z "
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 83 L 145 83.5 L 132.5 84 L 132.5 83 Z "
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 84 L 91.5 87 L 89.5 84 Z "
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 88 L 94.5 90 L 93.5 88 Z "
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 88 L 164.5 94 L 169.5 88 Z "
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 88 L 172 89.5 L 170 90.5 L 171.5 88 Z "
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 90 L 73 93.5 L 72 93.5 L 70.5 90 Z "
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 91 L 98.5 93 L 97.5 91 Z "
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 95 L 160.5 97 L 161.5 95 Z "
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 98 L 112 99.5 L 110.5 99 L 109.5 98 Z "
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 98 L 165 99.5 Q 165.8 101.8 163.5 101 L 165.5 98 Z "
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 102 L 125 102.5 L 121.5 103 L 121.5 102 Z "
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 102 L 146 102.5 L 141.5 103 L 141.5 102 Z "
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 103 L 84.5 106 L 82.5 103 Z "
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 103 L 136 103.5 L 131.5 104 L 131.5 103 Z "
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 107 L 155.5 109 L 156.5 107 Z "
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 109 L 91.5 111 L 90.5 109 Z "
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 112 L 97.5 114 L 96.5 112 Z "
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 116 L 140 116.5 L 137.5 118 L 138.5 116 Z "
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 117 L 112 117.5 L 108.5 118 L 108.5 117 Z "
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 136 L 43 136.5 L 39.5 137 L 39.5 136 Z "
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 165 Q 96.3 168.1 98 166.5 L 96.5 168 L 94.5 165 Z "
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 166 L 114 169.5 L 113 169.5 L 113.5 166 Z "
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 167 L 141.5 169 L 140 168.5 L 142.5 167 Z "
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 168 L 84 170.5 L 83 170.5 L 82.5 168 Z "
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 168 L 106 168.5 L 103.5 169 L 103.5 168 Z "
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 168 L 172 170.5 L 171 170.5 L 171.5 168 Z "
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 168 L 177.5 170 L 176.5 168 Z "
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 168 L 183 168.5 L 180.5 169 L 180.5 168 Z "
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 169 L 164.5 171 L 165.5 169 Z "
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 170 L 107 172.5 L 105 173.5 L 106.5 170 Z "
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 171 L 166.5 173 L 167.5 171 Z "
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 172 L 158 174.5 L 157 174.5 L 157.5 172 Z "
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 172 L 186 173.5 L 184.5 173 L 181.5 174 L 181.5 173 L 183.5 172 Z "
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,248,254)",
    stroke: "rgb(239,248,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 174 L 149.5 176 L 150.5 174 Z "
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 14 L 106 16.5 L 104 17.5 L 105 15.5 L 104.5 14 Z "
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 16 L 98.5 18 L 97.5 16 Z "
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 33 L 134.5 35 L 133.5 33 Z "
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 38 L 169.5 40 L 170.5 38 Z "
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 44 L 128.5 46 L 129.5 44 Z "
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 48 L 109.5 50 L 108.5 48 Z "
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 58 L 117.5 61 L 115.5 58 Z "
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 58 L 171 59.5 L 169 60.5 L 170.5 58 Z "
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 63 L 78 64.5 L 77.5 66 L 77 64 L 75.5 63 Z "
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 65 L 163.5 67 L 162 66.5 L 164.5 65 Z "
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 66 L 101.5 68 L 100.5 66 Z "
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 79 L 120.5 81 L 119.5 79 Z "
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 94 Q 73.8 93.3 73 95.5 L 71.5 94 Z "
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 99 L 152 99.5 L 148.5 100 L 148.5 99 Z "
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 100 L 77.5 102 L 76.5 100 Z "
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 121 L 58.5 123 L 57.5 121 Z "
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 127 Q 46.3 125.3 48 128.5 L 46.5 128 L 39.5 128 L 39.5 127 Z "
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 133 L 87 135.5 L 86 135.5 L 86.5 133 Z "
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 134 L 186.5 136 L 185.5 134 Z "
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 134 L 206.5 136 L 205.5 134 Z "
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 136 L 172.5 139 L 174.5 136 Z "
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 147 L 133 147.5 L 130.5 148 L 130.5 147 Z "
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 147 L 146 147.5 L 134.5 148 L 134.5 147 Z "
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 148 L 119 151.5 L 118 151.5 L 118.5 148 Z "
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91 164 L 93 164.5 L 91 165.5 L 91 164 Z "
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 168 L 127 168.5 L 124.5 169 L 124.5 168 Z "
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 171 L 148.5 173 Q 145.7 173.7 147.5 171 Z "
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 172 L 28 172.5 L 23.5 173 L 23.5 172 Z "
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 172 L 110 175.5 L 108 176 L 107.5 172 Z "
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,247,240)",
    stroke: "rgb(250,247,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 175 L 133.5 177 L 134.5 175 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJquery);
export default __webpack_public_path__ + "static/media/icon_jquery.353a2a07b8e6373d97c5cefb1c0f0bb0.svg";
export { ForwardRef as ReactComponent };